import SVG from 'react-inlinesvg'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const DetailButton = ({ title }) => {
  return (
    <SVG
      width={24}
      src={toAbsoluteUrl('/media/icons/noun-plus-5722914.svg')}
      className='svg-plus-image'
      title={title}
    />
  );
};

export default DetailButton;